import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";
import type { ThemeName } from "../context/ThemeContext";

interface ThemeState {
  theme: ThemeName;
  setTheme: (theme: ThemeName) => void;
  themes: readonly ThemeName[];
}

export function useTheme(): ThemeState {
  const context = useContext(ThemeContext);
  if (context === null) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
